<template>
  <div class="app-layout">
    <!-- 页头组件 -->
    <TheHeader />
    <NewUserSignupCampaignBanner
      v-if="shouldShowSignupCampaignBanner"
      @dismiss="handleDismissSignupCampaignBanner"
    />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <slot />
    </main>

    <!-- 页脚组件 -->
    <TheFooter />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useUserStore } from '~/stores/user';
import { getSignupCampaignBannerDismissed } from '~/utils/campaignBannerDismissal';
import { shouldShowNewUserBanner } from '~/utils/campaignBannerVisibility';

const route = useRoute();
const userStore = useUserStore();
const isSignupCampaignBannerDismissed = ref(false);

const shouldShowSignupCampaignBanner = computed(() => {
  return shouldShowNewUserBanner(
    route.path,
    userStore.isLoggedIn,
    isSignupCampaignBannerDismissed.value
  );
});

const handleDismissSignupCampaignBanner = () => {
  isSignupCampaignBannerDismissed.value = true;
};

onMounted(() => {
  isSignupCampaignBannerDismissed.value = getSignupCampaignBannerDismissed();
});
</script>

<style scoped lang="scss">
.app-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  // 移除默认padding，让页面组件自己控制间距
  // padding: $spacing-lg;
}

// 响应式布局优化
@media (max-width: 768px) {
  .app-layout {
    min-height: 100vh;
  }
}
</style>
